import dayjs from "dayjs";
import { useKycVerificationContext } from "../../Contexts/KycVerificationContext";
import React from "react";

function Review() {
  const { formData } = useKycVerificationContext();

  const renderName = () => {
    let fname = formData.firstName || "";
    let mname = formData.middleName || "";
    let lname = formData.lastName || "";

    let fullName =
      (fname ? fname + " " : "") +
      (mname ? mname + " " : "") +
      (lname ? lname : "");

    return fullName;
  };

  const renderAddress = () => {
    let address1 = formData.bldgName || "";
    let address2 = formData.street || "";
    let address3 = formData.subdivision || "";
    let address4 = formData.areaCode || "";
    let address5 = formData.zipCode || "";

    let address =
      (address1 ? address1 + " " : "") +
      (address2 ? address2 + " " : "") +
      (address3 ? address3 + " " : "") +
      (address4 ? address4 + " " : "") +
      (address5 ? address5 : "");

    return address;
  };

  const renderMothersName = () => {
    let fname = formData.mothersFirstName || "";
    let mname = formData.mothersMiddleName || "";
    let lname = formData.mothersLastName || "";

    let fullName =
      (fname ? fname + " " : "") +
      (mname ? mname + " " : "") +
      (lname ? lname : "");

    return fullName;
  };

  return (
    <div className="p-4">
      <p className="text-[#1F2328] text-xl font-bold mb-1">
        Review personal information
      </p>
      <p className="text-[#60656D] mb-4">
        Before proceeding further, please take a moment to ensure that all your
        personal details are accurate and up-to-date. This helps to ensure a
        smooth and efficient process.
      </p>
      <div className="mb-2">
        <p className="font-semibold mb-1">Name</p>
        <p>{renderName() || "-"}</p>
      </div>
      <div className="mb-2">
        <p className="font-semibold mb-1">Gender</p>
        <p>{formData.gender || "-"}</p>
      </div>
      <div className="mb-2">
        <p className="font-semibold mb-1">Date of Birth</p>
        <p>
          {(formData.dateOfBirth &&
            dayjs(formData.dateOfBirth).format("MM/DD/YYYY")) ||
            "-"}
        </p>
      </div>
      <div className="mb-2">
        <p className="font-semibold mb-1">Place of Birth</p>
        <p>{formData.placeOfBirth || "-"}</p>
      </div>
      <div className="mb-2">
        <p className="font-semibold mb-1">Valid ID Number</p>
        <p>{formData.idNumber || "-"}</p>
      </div>
      <div className="mb-2">
        <p className="font-semibold mb-1">Mobile Number</p>
        <p>{(formData.mobileNumber && "+63" + formData.mobileNumber) || "-"}</p>
      </div>
      <div className="mb-2">
        <p className="font-semibold mb-1">Email Address</p>
        <p>{formData.emailAddress}</p>
      </div>
      <div className="mb-2">
        <p className="font-semibold mb-1">Address</p>
        <p>{renderAddress() || "-"}</p>
      </div>
      <div className="mb-2">
        <p className="font-semibold mb-1">Nationality</p>
        <p>{formData.nationality || "-"}</p>
      </div>
      <div className="mb-2">
        <p className="font-semibold mb-1">Mother's Maiden Name</p>
        <p>{renderMothersName() || "-"}</p>
      </div>
      <div className="mb-2">
        <p className="font-semibold mb-1">Company Name / Employer Name</p>
        <p>{formData.companyName || "-"}</p>
      </div>
    </div>
  );
}

export default Review;
